<div class="field"
     [ngClass]="{'disabled': isDisabled, 'error': hasErrors()}"
     [hidden]="isHidden"
>
  <label *ngIf="controlOptions.label">{{controlOptions.label}}</label>
  <!-- из-за того, что autofocus и suiPopup нельзя забиндить приходится готодить такой огород -->
  <!-- текстария имеет хинт и фокус ввода -->
  <textarea *ngIf="controlOptions.isFocused && controlOptions.hint"
            [name]="controlId"
            [readonly]="isReadOnly"
            [formControl]="formControlInstance"
            [placeholder]="controlOptions.placeholder"
            [cols]="controlOptions.cols"
            [rows]="controlOptions.rows"
            [tabIndex]="disabledTabIndex()"
            autofocus
            suiPopup
            popupText="{{controlOptions.hint}}"
  ></textarea>
  <!-- текстария имеет хинт, но без фокуса -->
  <textarea *ngIf="!controlOptions.isFocused && controlOptions.hint"
            [name]="controlId"
            [readonly]="isReadOnly"
            [formControl]="formControlInstance"
            [placeholder]="controlOptions.placeholder"
            [cols]="controlOptions.cols"
            [rows]="controlOptions.rows"
            [tabIndex]="disabledTabIndex()"
            suiPopup
            popupText="{{controlOptions.hint}}"
  ></textarea>
  <!-- текстария без хинта, но с фокусом ввода -->
  <textarea *ngIf="controlOptions.isFocused && !controlOptions.hint"
            [name]="controlId"
            [readonly]="isReadOnly"
            [formControl]="formControlInstance"
            [placeholder]="controlOptions.placeholder"
            [cols]="controlOptions.cols"
            [rows]="controlOptions.rows"
            [tabIndex]="disabledTabIndex()"
            autofocus
  ></textarea>
  <!-- обычная текстария без хинта и фокуса -->
  <textarea *ngIf="!controlOptions.isFocused && !controlOptions.hint"
            [name]="controlId"
            [readonly]="isReadOnly"
            [formControl]="formControlInstance"
            [placeholder]="controlOptions.placeholder"
            [cols]="controlOptions.cols"
            [rows]="controlOptions.rows"
            [tabIndex]="disabledTabIndex()"
  ></textarea>
</div>
<div *ngIf="hasErrors()" class="ui pointing red label">
  {{errorMessage}}
</div>
